module.exports = __webpack_public_path__ + "static/media/instamaps_small@3x.04f4369d.jpg";